<template>
  <div class="swiper" :class="className" :swiperOptions="swiperOptions">
    <div class="swiper-wrapper">
      <slot></slot>
    </div>
    <div class="swiper-pagination"></div>
    <div class="swiper-scrollbar"></div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</template>

<script>
import { Swiper } from 'swiper';
import { Navigation, Pagination, Autoplay, Scrollbar } from 'swiper/modules';

export default {
  props: {
    swiperOptions: {
      type: Object,
      default() {
        return {};
      },
    },
    className: {
      type: String,
      required: false,
      default: null,
    },
  },
  mounted() {
    Swiper.use([Navigation, Pagination, Autoplay, Scrollbar]);
    new Swiper(this.className ? `.${this.className}` : '.swiper', this.swiperOptions);
  },
};
</script>
